import React from 'react';
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
  Pagination,
  Typography,
} from '@mui/material';

interface PageControlsProps {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (event: React.ChangeEvent<unknown>, value: number) => void;
  onPageSizeChange?: (event: SelectChangeEvent<number>) => void;
  itemLabel?: string;
  showPageSize?: boolean;
}

const PageControls: React.FC<PageControlsProps> = ({
  page,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
  itemLabel = 'Claims',
  showPageSize = true,
}) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {showPageSize && (
          <>
            <Typography variant="body2">
              Page Size
            </Typography>
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <Select
                value={pageSize}
                onChange={onPageSizeChange}
                displayEmpty
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
          </>
        )}
        <Typography variant="body2" sx={{ ml: showPageSize ? 1 : 0 }}>
          {total > 0
            ? `Showing ${(page - 1) * pageSize + 1}-${Math.min(page * pageSize, total)} of ${total} ${itemLabel}`
            : `Showing 0-0 of 0 ${itemLabel}`}
        </Typography>
      </Box>
      <Pagination 
        count={total > 0 ? Math.ceil(total / pageSize) : 1}
        page={page}
        onChange={onPageChange}
        color="primary"
      />
    </Box>
  );
};

export default PageControls;

